import { enUS, es, hy, id, ru, th, zhCN } from "date-fns/locale";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/hy-am";
import "dayjs/locale/id";
import "dayjs/locale/ru";
import "dayjs/locale/th";
import "dayjs/locale/zh-cn";

const normalizeLanguage = (language) => {
  const normalized = (language || "en").trim().toLowerCase();

  if (normalized.startsWith("zh")) {
    return "zh";
  }

  if (normalized === "idn") {
    return "id";
  }

  return normalized.split(/-|_/)[0] || "en";
};

const dateFnsLocales = {
  en: enUS,
  es,
  hy,
  id,
  ru,
  th,
  zh: zhCN,
};

const dayjsLocales = {
  en: "en",
  es: "es",
  hy: "hy-am",
  id: "id",
  ru: "ru",
  th: "th",
  zh: "zh-cn",
};

export const getDateFnsLocale = (language) =>
  dateFnsLocales[normalizeLanguage(language)] || enUS;

export const getDayjsLocale = (language) =>
  dayjsLocales[normalizeLanguage(language)] || "en";
